import 'tippy.js/animations/shift-toward.css';
import 'tippy.js/dist/tippy.css';

import React from 'react';
import type { ComponentPropsWithoutRef } from 'react';
import { followCursor } from 'tippy.js';
import { MediaQuery } from '@context/mediaQuery';
import { LazyTippy } from './LazyTippy';
import { useGetLayoutContainer } from './main-components/useGetLayoutContainer';

export const BackerPopup = ({
  isDisabled,
  children,
  className,
  content,
}: {
  children: ComponentPropsWithoutRef<typeof LazyTippy>['children'];
  isDisabled?: boolean;
  className?: string;
  content: React.ReactNode;
}) => {
  const { tablet } = MediaQuery.useContainer();

  const layoutElement = useGetLayoutContainer();

  const avatarClosePopoverOnClick = tablet ? {} : { hideOnClick: true, trigger: 'click' };

  return (
    <LazyTippy
      className={className}
      plugins={[followCursor]}
      followCursor={false} // explicit for readability
      arrow={false}
      interactive
      placement="top"
      animation={tablet ? 'fade' : 'shift-toward'}
      disabled={isDisabled}
      content={content}
      appendTo={() => document.body}
      {...avatarClosePopoverOnClick}
      popperOptions={{
        modifiers: [
          {
            name: 'preventOverflow',
            options: {
              boundary: layoutElement,
            },
          },
        ],
      }}
    >
      {children}
    </LazyTippy>
  );
};
